import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';

@Component({
	selector: 'app-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('popupForm', { static: true }) popupForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	popupFormSubscription: Subscription;
	font;
	fonts: Array<Font>;
	isAdmin;

	constructor(private comService: ComponentService, private fontsService: FontsService, private auth: AuthService) {}

	ngOnInit() {
		if (!this.componentData.config.use_external) {
			this.componentData.config.use_external = {};
			this.componentData.config.use_external.image = false;
			this.componentData.config.use_external.add_image_tracking = false;
			this.componentData.config.use_external.link = false;
			this.componentData.config.use_external.add_link_tracking = false;
		}

		this.isAdmin = this.auth.isAdmin();

		this.popupFormSubscription = this.popupForm.valueChanges
			.pipe(
				tap(() => this.comService.updateDisabledSave(this.popupForm.invalid || this.nameField.editComponentName)),
				filter((form) => this.popupForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		this.fonts = this.fontsService.getFonts();

		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.font) === -1
				? 'Custom Font'
				: this.componentData.config.font;
	}

	ngOnDestroy() {
		this.popupFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}
}
